import { render, staticRenderFns } from "./GroupsLogs.vue?vue&type=template&id=3792e416&"
import script from "./GroupsLogs.vue?vue&type=script&lang=js&"
export * from "./GroupsLogs.vue?vue&type=script&lang=js&"
import style0 from "./GroupsLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports